import React from 'react';
import SvgIconButton, { SvgIconButtonProps } from '../common/SvgIconButton';
import useGame from '../../hooks/use-game';
import { NavigationDirection } from '../../types';
import isLastPage from '../../util/is-last-page-util';

export type NavigationButtonProps = SvgIconButtonProps & {
  direction: NavigationDirection;
};

const ArrowNavigationButton: React.FC<NavigationButtonProps> = ({ direction, ...props }) => {
  const [gameState, { handleTurnActivityPage }] = useGame();

  const disabled = gameState.activityState.showAnimation || props.disabled;

  const displayPulsingEffect =
    !disabled &&
    direction === NavigationDirection.Next &&
    gameState.activityState.currentPageCompleted &&
    !isLastPage(gameState);

  return (
    <SvgIconButton
      {...props}
      pulsing={displayPulsingEffect}
      onClick={() => handleTurnActivityPage(direction)}
      disabled={disabled}
    />
  );
};

export default ArrowNavigationButton;
